<template>
  <div v-show="isShow" style="position: absolute;top:35%;left:35%;width:350px">
    <a href='javascript:;' @click="closeInfo"
      style="z-index:2000;width:20px;height:20px;position:absolute;top:18px;right:4%;cursor:pointer;">
      <img src="@assets/point_close.png" align="right" />
    </a>

    <div id="infoBox">
      <div class='point-content'>
        <div class='point-top'>
          <div class='pointInfo-content'>

            <ul>
              <li>
                <span class='point-name'>{{info ? info.entity : ''}}</span>
                <span>-</span>
                <span class='point-group'>{{info ? info.org : ''}}</span>
                <!-- <span>-</span>
                <span class='point-remark'>{{info ? info.group : ''}}</span> -->
              </li>
              <li>
                <label>{{$t('home.statu')}}：</label>
                <span v-if="info">
                  {{info.onlineStatus ? $t('home.online') : $t('home.offline')}}
                  <span v-if="info">
                  <span :class="info.onlineStatus ? 'icon-online icon-md' : 'icon-offline icon-md'">
                    <zx-icon type="icon-shoubiao"></zx-icon>
                  </span>
                  <span>{{info.model ? info.model : '---'}}</span>
                </span >
                  <span  class="span-gap" v-if="info.onlineStatus">
                    <span class="icon-md" :title="computedLocationType(info.loc_type).value">
                      <zx-icon :type="computedLocationIcon(info.loc_type, info.radius)">
                      </zx-icon>
                    </span>
                  </span>
                </span>
                
                

                <span class="span-gap">
                  <i v-if="info && info.alarmNum && info.alarmNum > 0"
                    onclick="window.showDetail('alarm')"
                    :class="info.alarmNum ? 'icon-alarm icon-md' : 'icon-offline icon-md'">
                    <zx-icon type="icon-gaojing"></zx-icon>
                  </i>
                </span>

                <span class="span-gap">
                  <i v-if="info && info.absentStatus" class="icon-online icon-md">
                    <zx-icon type="icon-qingjia"></zx-icon>
                  </i>
                </span>

              </li>
              <li v-show="info && info.model.includes('Z62')">
                <!-- 开锁授权检测和开锁 -->
                <label>{{$t('home.command')}}：</label>
                <!-- <span class="span-gap"> -->
                <span>
                  <span v-if="!isOpenLockSending">
                    <a v-if="info && info.onlineStatus && info.capbility_elock && !info.capbility_lock_detect"  href='javascript:;'>
                      <i onClick="window.sendCommand('3')" :class="info.onlineStatus ? 'icon-online icon-md' : 'icon-offline icon-md'" :title="$t('home.sendUnlockCommand')">
                        <zx-icon type="icon-ai243"></zx-icon>
                      </i>
                      <span class="span-noraml">{{$t('home.sendUnlockCommand')}}</span>
                    </a>
                    <!-- 存在开启检测的功能，Z60系例 且是开启状态， 下发4的命令让其关闭 -->
                    <a v-if="info && info.onlineStatus && info.capbility_lock_detect && info.wearcheck == 1" href='javascript:;'
                      onClick="window.sendCommand('4')">
                      <!-- 开启检测 3  -->
                      <i :class="info.wearcheck == 1 ? 'icon-online icon-md' : 'icon-offline icon-md'" :title="$t('home.sendCommandToNonuseseWearCheck')">
                        <zx-icon type="icon-jiance2"></zx-icon>
                      </i>
                      <span class="span-noraml">{{$t('home.useWearCheck')}}</span>
                    </a>
                    <!-- 存在开启检测的功能，Z60系例 且是关闭状态， 下发5的命令让其开启 -->
                    <a v-if="info && info.onlineStatus && info.capbility_lock_detect && info.wearcheck != 1" href='javascript:;'
                      onClick="window.sendCommand('5')">
                      <!-- 关闭检测 5  -->

                      <i :class="info.wearcheck == 1 ? 'icon-online icon-md' : 'icon-offline icon-md'" :title="$t('home.sendCommandToUseWearCheck')">
                        <zx-icon type="icon-jiance2"></zx-icon>
                      </i>
                      <span class="span-noraml">{{$t('home.nonuseWearCheck')}}</span>
                    </a>
                    <!-- <span v-else>---</span> -->
                  </span>
                  
                  <i v-else class="icon-online icon-md">
                    <a-spin size="small">
                      <zx-icon slot="indicator" type="icon-loading1" spin />
                    </a-spin>
                  </i>

                  <!-- 优先GPS？ -->
                  <!-- <a v-if="info.deviceFlags && info.deviceFlags % 2 === 1"  onClick="window.changeGps()">

                    <i :class="info.flags && info.flags % 2 === 1 ? 'icon-online icon-md' : 'icon-offline icon-md'" title="优先GPS">
                      <zx-icon type="icon-gps"></zx-icon>
                    </i>
                    <span class="span-noraml">{{info.flags && info.flags % 2 === 1 ? '开启GPS' : '关闭GPS'}}</span>
                  </a> -->

                </span>
              </li>

              <!-- 位置 -->
              <li>
                <label>{{$t('home.location')}}：</label>
                <span :title="info.position_time ? timeFormat(info.position_time) : ''" class="address" v-if="info && info.lat && info.lng">
                  {{info.address}}
                </span>
                <span v-if="info && info.lat && info.lng" class="span-gap">
                  <a v-show="!isGetAddressSending && info.onlineStatus && info.oui == 'ZX'" href='javascript:;' onClick="window.sendCommand('2')">
                    <i class="icon-link icon-md" :title="$t('home.sendLocationCommand')">
                      <zx-icon type="icon-gengxin"></zx-icon>
                    </i>
                  </a>
                  <span onClick="window.sendCommand('2')" v-show="!isGetAddressSending && !info.onlineStatus">
                    <i class="icon-offline icon-md">
                      <zx-icon type="icon-gengxin"></zx-icon>
                    </i>
                  </span>
                  <i v-show="isGetAddressSending" class="icon-online icon-md">
                    <a-spin size="small">
                      <zx-icon slot="indicator" type="icon-loading1" spin />
                    </a-spin>
                  </i>
                </span>
                <span v-else>---</span>
              </li>

              <!-- <li  v-if="info && info.loc_type">
                                <label>信号：</label>
                                <span>
                                    <i class="icon-md">
                                        <zx-icon :type="info.loc_type == 'wifi' ? 'icon-wifi' : 'icon-xinhao-copy-copy-copy-copy-copy'"></zx-icon>
                                    </i>
                                </span>
                            </li> -->
              <!-- <li>
                <label>{{`周边`}}：</label><span v-if="info && info.surroundingPois">{{info.surroundingPois[0].title}} <span v-if="info.surroundingPois[0].distance">{{` 约${info.surroundingPois[0].distance}米`}}</span> </span>
              </li> -->
              <li>
                <label>{{$t('home.latitudeLongitude')}}：</label><span v-if="info">{{info.lat && info.lng ? info.lat + ',' + info.lng : $t('home.noData')}}</span>
              </li>
              <li>
                <label>{{$t('home.time')}}：</label><span v-if="info">{{info.timestamp ? timeFormat(info.timestamp) : $t('home.noData')}}</span>
              </li>
            </ul>

            <div class="item-health"> 
              <div v-if="info" class="item" :title="info.power ? '电量：' + info.power + '%' : ''">
                <i class="icon-statu icon-link">
                  <zx-icon :type="computedDevicePowerIcon(info.power)"></zx-icon>
                </i>
                <span >{{info.power ? info.power + '%' : ''}}</span>
              </div>
 
              <div class="item" :title="info && info.step && info.step_time ? '步数：' + info.step + $t('home.step') : ''" v-if="info && info.capbility_step">
                <i class="icon-statu icon-link">
                  <zx-icon type="icon-jjj1"></zx-icon>
                </i>

                <span v-if="info && !isGetStepSending">{{info.step && info.step > 0 ? info.step + $t('home.step') : ''}}</span>
                <i v-else class="icon-online icon-md">
                  <a-spin size="small">
                    <zx-icon slot="indicator" type="icon-loading1" spin />
                  </a-spin>
                </i>
              </div>
              
              <div class="item" :title="info && info.heartbeat && info.heart_beat_time ? '心率：' + info.heartbeat + $t('home.beatPerMin')  : ''" v-if="info && info.capbility_heartrate">
                <a v-if="info && info.onlineStatus && info.capbility_heartrate && info.oui == 'ZX'" >
                <!-- onClick="window.sendCommand('1')"> -->
                  <!-- <i class="icon-statu icon-link" :title="$t('home.sendCommandToInstantHeartRate')"> -->
                  <i class="icon-statu icon-link">
                    <zx-icon type="icon-xinlv"></zx-icon>
                  </i>
                </a>
                <span v-else>
                  <i class="icon-statu icon-link">
                    <zx-icon type="icon-xinlv"></zx-icon>
                  </i>
                </span>

                <span v-if="info  && !isGetHeartRateSending">{{info.heartbeat  && info.heartbeat > 0 ? info.heartbeat + $t('home.beatPerMin') : ''}}</span>
                <i v-else class="icon-online icon-md">
                  <a-spin size="small">
                    <zx-icon slot="indicator" type="icon-loading1" spin />
                  </a-spin>
                </i>
              </div>
<!--               
              <div class="item" v-if="info && info.capbility_temperature" :title="info && info.bodyTemperature ? '体温：' + info.bodyTemperature + '℃' : info.wristTemperature ? '腕温：' + info.wristTemperature + '℃' : info.handTemperature ? '体温：' + info.handTemperature + '℃' : ''">
                  <i class="icon-statu icon-link">
                    <zx-icon type="icon-tiwen"></zx-icon>
                  </i> 
                  <span>{{info.bodyTemperature ? info.bodyTemperature + '℃' : '' }}</span>
              </div> -->

              <!-- <div class="item temp-item" v-if="temperatureList.length" :title="temperatureList.map(t => `${t.label}：${t.value}℃`).join('、')">
                <i class="icon-statu icon-link">
                  <zx-icon type="icon-tiwen"></zx-icon>
                </i>
                <div class="temp-col">
                  <span v-for="t in temperatureList" :key="t.key" :title="`${t.label}：${t.value}℃`">
                    {{ t.value }}℃
                  </span>
                </div>
              </div> -->

              <div class="item temp-item" v-if="temperature" :title="temperature.title">
                <i class="icon-statu icon-link">
                  <zx-icon type="icon-tiwen"></zx-icon>
                </i>
                <span>{{ temperature.value }}℃</span>
              </div>

              <!-- <div class="item" v-if="info && info.capbility_blood_pressure" :title="info && info.systolicPressure && info.diastolicPressure ? '血压：' + info.systolicPressure + '/' + info.diastolicPressure + 'mmHg' : ''">
                  <i class="icon-statu icon-link">
                    <zx-icon type="icon-xieya2"></zx-icon>
                  </i>
                  <span>{{info.systolicPressure && info.diastolicPressure ? info.systolicPressure + '/' + info.diastolicPressure + 'mmHg' : ''}}</span>
              </div> -->

              <div class="item" v-if="bloodPressureList.length" :title="bloodPressureList.map(t => `${t.label}：${t.value}mmHg`).join('、')">
                <i class="icon-statu icon-link">
                  <zx-icon type="icon-xieya2"></zx-icon>
                </i>
                <div>
                    <span>{{bloodPressureList.length == 2 ? bloodPressureList[0].value + '/' + bloodPressureList[1].value + 'mmHg' : ''}}</span>
                
                </div>
              </div>

              

               <div class="item" v-if="info && info.capbility_blood_oxygen" :title="info && info.bloodOxygen ? '血氧：' + info.bloodOxygen + '%' : ''">
                  <i class="icon-statu icon-link">
                    <zx-icon type="icon-xieyang1"></zx-icon>
                  </i>
                  <span>{{info.bloodOxygen ? info.bloodOxygen + '%' : ''}}</span>
              </div>

            </div>  
          </div>
        </div>
        <div class='point-bottom' v-if="info && info.lat && info.lng">
          <ul>
            <li><a onclick="window.showDetail('entity')">{{$t('home.info')}}</a></li>
            <li><a onclick='window.showTrack()'>{{$t('home.track')}}</a></li>
            <li v-if="info.capbility_heartrate || info.capbility_step"><a onclick="window.showDetail('health')">{{$t('home.health')}}</a></li>
            <li><a onclick="window.showDetail('alarm')">{{$t('home.alarms')}}</a></li> 
          </ul>
        </div>
      </div>
      <div class='point-arrow' v-if="info && info.lat && info.lng"></div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapState} from 'vuex'
  import config from '@/config'
  import {
    TransForm
  } from '@/assets/js/transform.js'
  import {computedDevicePowerIcon, computedLocationIcon, computedLocationType} from '../../utils/homeFn'
  import closeImg from '../../assets/point_close.png'
  import moment from 'moment'
  import bus from '../../bus/bus';
  import {getLocalPosition, parsePoint} from '../../utils/getLocalPosition'
  import {transToBD09} from '../../utils/globalFunction'


  export default {

    name: "ZInfoBox",
    data() {
      return {
        // 是否正在下发开锁或者支持或取消检测功能
        isOpenLockSending: false,
        // 是否正在获取步数
        isGetStepSending: false,
        // 是否正在获取心率
        isGetHeartRateSending: false,
        // 是否正在获取地址
        isGetAddressSending: false,
        // 用于记录多个实体的查询状态
        entitysSendStatus: [],
        // 所有状态名称
        sendingNames: ['isOpenLockSending', 'isGetStepSending', 'isGetHeartRateSending', 'isGetAddressSending'],
        // 记录的上一次地点
        recordedPoint: '',
        infoBox: null,
        info: null,
        isShow: false
      }
    },
    mounted() {
      window.sendCommand = this.sendCommand
      window.showDetail = this.showDetail
      window.showTrack = this.showTrack
      window.changeGps = this.changeGps
      bus.$on('freshInfoBox', () => {
        console.log(this.boxInfo)
        this.freshInfoBox()
      })
      bus.$on('langChanged', (lang) => {
        // console.log(lang)
        this.$nextTick().then(() => {
          this.freshInfoBox()
        })
      })
      // console.log(this.$socket)
      // console.log(this.token)
      this.$socket.emit('init', this.token)
    },
    beforeDestroy () {
      bus.$off('freshInfoBox')
      bus.$off('langChanged')
    },
    computed: {
      ...mapGetters(['token']),
      ...mapState({
        boxInfo: state => state.home.boxInfo
      }),
       temperatureList() {
        const i = this.info || {}
        if (!i.capbility_temperature) return []
        return [
          { key: 'wrist', label: '腕温', value: i.wristTemperature },
          { key: 'body',  label: '体温', value: i.bodyTemperature }, 
        ].filter(t => t.value !== undefined && t.value !== null && t.value !== '')
      },

      temperature() {
        const i = this.info || {}
        if (!i.capbility_temperature) return null
        const list = [
          { key: 'body',  label: '体温', value: i.bodyTemperature }, 
          { key: 'wrist', label: '腕温', value: i.wristTemperature }
        ]
        const hit = list.find(t => t.value !== undefined && t.value !== null && t.value !== '')
        return hit ? { ...hit, title: `${hit.label}：${hit.value}℃` } : null
      },
      bloodPressureList() {
        const i = this.info || {}
        if (!i.capbility_blood_pressure) return []
        return [
          { key: 'systolic', label: '收缩压', value: i.systolicPressure },
          { key: 'diastolic', label: '舒张压', value: i.diastolicPressure },
        ].filter(t => t.value !== undefined && t.value !== null && t.value !== '')
      }
    },
    methods: {
      computedDevicePowerIcon,
      computedLocationIcon,
      computedLocationType,
      ...mapMutations(['setOpenedInfoBoxId', 'setBoxInfo']),
      closeInfo() {
        this.isShow = false
      },
      closeInfoBox() {
        if (this.infoBox) {
          this.infoBox.close()
          this.infoBox = null
        }
      },
      showInfo(info) {
        /*
        this.info = info
        this.isShow = true
        */
        //    console.log(info)
        this.closeInfoBox()
        if (info.deviceId) {
          let param = {
            commands: [{commandId : 2}],
            entityIds: [info.id]
          }
          this.$http.post(config.api.entity_command_url, param).then(() => {
            this.$notification["warning"]({
              message: this.$t('home.noLocationTip'),
              description: this.$t('home.noLocationDescription'),
            })
            this.$emit('showDetail', info, 'entity')
          })
        } else {
            /*
          this.$notification["warning"]({
            message: '提示',
            description: '当前实体未绑定设备',
          })
          */
          this.$emit('showDetail', info, 'entity')
        }

      },
      showTrack() {
        this.$emit('showTrack', this.info)
      },
      showDetail(type) {
        this.$emit('showDetail', this.info, type)
      },
      // 计算当前实体目前的状态
      computedCurrentStatu (type) {
        // console.log(`compute ${type} statu`)
        // 判断是否有状态记录
        let entityIndex = this.entitysSendStatus.findIndex((item) => item.entityId && item.entityId === this.info.id)
        // 如果没有直接返回false
        if (entityIndex === -1) {
          return false
        } else {
          // console.log(this.entitysSendStatus[entityIndex][type])
          return this.entitysSendStatus[entityIndex][type] || false
        }
      },
      // 修改实体的下发命令状态,需要该实体的id,命令类型
      setSendStatus(entityId, commandType, value) {
        // 检查之前是否有该实体的操作记录
        let entityIndex = this.entitysSendStatus.findIndex((item) => item.entityId && item.entityId === entityId)
        // 有操作记录
        if (entityIndex !== -1) {
          // 修改该记录的状态
          this.entitysSendStatus[entityIndex][commandType] = value
        } else {
          // 没有操作记录
          // 就添加一个记录
          let statu = {
            // id
            entityId,
          }
          statu[commandType] = value
          this.entitysSendStatus.push(statu)
        }
        // console.log(this.entitysSendStatus)
        // 修改的是当前框
        if (this.info.id === entityId) {
          this[commandType] = value
          
          // console.log(this[commandType])
        }
        // 设置定时器80秒后状态未改变则手动改变
        // 如果将状态改为正在获取某项数据
        if (value === true) {
          setTimeout(() => {
            let entityIndex = this.entitysSendStatus.findIndex((item) => item.entityId && item.entityId === entityId)
            // 如果45秒后状态任然未改变则说明socket失败了，手动修改数据
            if (entityIndex !== -1 && this.entitysSendStatus[entityIndex][commandType] === true) {
              console.log('socket is failed, update statu')
              // 更新状态
              this.entitysSendStatus[entityIndex][commandType] = false
              if (this.info.id === entityId) {
                this[commandType] = false
                this.$notification.error({
                  message: this.$t('home.requestTimeOut')
                })
              }
              // console.log(this[commandType])
              this.$nextTick().then(() => {
                this.freshInfoBox()
              })
            }
          }, 80000)
        }
      },
      // 检测是否是已下发过命令的实体
      isSendedCommandEntity (entityId) {
        // 检查之前是否有该实体的操作记录
        let entityIndex = this.entitysSendStatus.findIndex((item) => item.entityId && item.entityId === entityId)
        // 有操作记录
        if (entityIndex !== -1) {
          return true
        } else {
          return false
        }
      },
      sendCommand(commandType) {
        let param = {}
        param.commands = []
        param.entityIds = []
        param.commands.push({
          'commandId': commandType
        })
        param.entityIds.push(this.info.id)
        // console.log(param)
        
        this.$http.post(config.api.entity_command_url, param).then((response) => {
          if (response.code == 0) {
            this.$message.success(this.$t('home.sendCommandSuccess'))
            // 下达开锁关锁或开关监控命令命令
            if (commandType == 3 || commandType == 4 || commandType == 5) {
              this.setSendStatus(this.info.id, 'isOpenLockSending', true)
            }
            // 获取心率
            if (commandType == 1) {
              this.setSendStatus(this.info.id, 'isGetHeartRateSending', true)
            }
            // 获取位置
            if (commandType == 2) {
              // this.isGetStepSending = true
              this.setSendStatus(this.info.id, 'isGetAddressSending', true)
            }
            this.$nextTick().then(() => {
              this.freshInfoBox()
            })
            
          } else {
            this.$notification.error(response.desc)
          }
        })
      },
      timeFormat(timestamp) {
        return moment(timestamp * 1000).format('YYYY/MM/DD HH:mm')
      },
      transToBd09(coord_type='bd09', lng, lat) {
        var tmpLat = +lat;
        var tmpLng = +lng;
        var tmp;
        if (coord_type == 'wgs84' || coord_type == 'WGS84') {
          tmp = TransForm.wgs84tobd09(tmpLng, tmpLat);
        } else if (coord_type == 'gcj02' || coord_type == 'GCJ02') {
          tmp = TransForm.gcj02tobd09(tmpLng, tmpLat);
        } else {
          tmp = [tmpLng, tmpLat];
        }
        tmp = [tmp[0].toFixed(6), tmp[1].toFixed(6)];
        return tmp;
      },
      freshInfoBox() {
        this.info = this.boxInfo
        // console.log(this.$el.children)
        // console.log(infoHtml)
        // console.log('fresh')
        // this.infoBox.setContent(this.$el.children[1])
        // 刷新位置
        let bd09Point = transToBD09(this.info.coord_type, this.info.lng, this.info.lat)
        let point = new BMap.Point(bd09Point.lng, bd09Point.lat)
        // if (point) {
        //   // console.log(pt)
        //   // console.log(this.infoBox)
        //   // this.transPointToAddress(pt)
        //   // this.infoBox.enableAutoPan()
        //   // this.marker.setPosition(pt)setPosition
        //   this.infoBox && this.infoBox.setPosition(point)
        // }
        let infoHtml = document.getElementById("infoBox").innerHTML
        this.infoBox && this.infoBox.setContent(infoHtml)
        this.infoBox && this.infoBox.setPosition(point)
        // (this.infoBox && point) && this.infoBox.setPosition(point)
      },
      show(marker, markerInfo, map) {
        this.$emit('closeDetail')
        // console.log(JSON.stringify(markerInfo))
        this.marker = marker
        let lnglat = this.transToBd09(markerInfo.coord_type, markerInfo.lng, markerInfo.lat)
        this.recordedPoint = {
          lng: lnglat[0],
          lat: lnglat[1],
          coord: 'bd09'
        }
        this.info = markerInfo
        console.log('info显示后的info:',this.info);
        // console.log(this.info)
        // console.log(this.entitysSendStatus)
        // 初始化状态
        // 计算当前实体是否有正在请求的数据,然后改变状态
        for (let i = 0; i < this.sendingNames.length; i++) {
          this[this.sendingNames[i]] = this.computedCurrentStatu(this.sendingNames[i])
        }
        // if (this.info.id != this.isGetHeartRateSending.entityId) {
        //   this.clearRoll()
        // }
        this.closeInfoBox()
        this.$emit('openedInfoBoxId', this.info.id)
        this.setOpenedInfoBoxId(this.info.id)

        this.info = {...this.info}
        if(!this.info.address) this.info.address = '暂时无法解析地址'
        this.setBoxInfo(this.info)
        this.$nextTick().then(() => {
          let infoHtml = document.getElementById("infoBox").innerHTML
          this.isShow = false
          this.infoBox = new window.BMapLib.InfoBox(map, infoHtml, {
            boxStyle: {
              width: "350px",
              height: "auto"
            },
            offset: new window.BMap.Size(0, 40),
            closeIconMargin: "8px",
            closeIconUrl: closeImg,
            enableAutoPan: true,
            align: window.INFOBOX_AT_TOP
          });
          this.infoBox.open(marker);
          this.infoBox.addEventListener("close", () => {
            this.$emit("clearOverlay")
            this.setOpenedInfoBoxId()
          });
        })

        // // 获取当前实体健康状态
        // this.$http.get(config.api.get_entity_current_health + this.info.id).then((res) => {
        //   if (res.code === 0) {
        //     this.info.step = res.result.step
        //     this.info.heartbeat = res.result.heart
            
        //     let _this = this
        //     // var geoc = new window.BMap.Geocoder()
        //     let pt = new window.BMap.Point(lnglat[0], lnglat[1])
        //     parsePoint(pt).then((res) => {
        //       // this.info.address = res.address
        //       if (res.surroundingPois.length > 0) {
        //         this.info.surroundingPois = res.surroundingPois.map((item) => {
        //           // 计算周边点与定位点之间的距离
        //           let distance = Math.round(map.getDistance(pt, item.point))
        //           return Object.assign({distance}, item)
        //         })
        //       } else if (res.business) {
        //         this.info.surroundingPois = [
        //           {
        //             title: res.business,
        //             distance: null
        //           }
        //         ]
        //       } else {
        //         this.info.surroundingPois = null
        //       }
        //       this.info = {...this.info}
        //       this.setBoxInfo(this.info)
        //       this.$nextTick().then(() => {
        //         let infoHtml = document.getElementById("infoBox").innerHTML
        //         // _this.closeInfoBox()
        //         this.isShow = false
        //         this.infoBox = new window.BMapLib.InfoBox(map, infoHtml, {
        //           boxStyle: {
        //             width: "350px",
        //             height: "auto"
        //           },
        //           offset: new window.BMap.Size(0, 40),
        //           closeIconMargin: "8px",
        //           closeIconUrl: closeImg,
        //           enableAutoPan: true,
        //           align: window.INFOBOX_AT_TOP
        //         });
        //         this.infoBox.open(marker);
        //         this.infoBox.addEventListener("close", () => {
        //           this.$emit("clearOverlay")
        //           this.setOpenedInfoBoxId()
        //         });
        //       })
        //     })
        //   }
        // })
      },
      // 判断接收到的socket事件类型
      checkSocketEventType (event) {
        // ['isOpenLockSending', 'isGetStepSending', 'isGetHeartRateSending', 'isGetAddressSending']
        if (event === 'lock') {
          return 'isOpenLockSending'
        } else if (event === 'heartRate') {
          return 'isGetHeartRateSending'
        } else if (event === 'location') {
          return 'isGetAddressSending'
        }
      },
      // socket返回成功后，更新当前infoBox的数据
      updateInfo (type, value) {
        let pt
        // 心率
        if (type === 'isGetHeartRateSending') {
          this.info.heartbeat = value
          this.info.heart_beat_time = this.$moment().unix()
          this.$notification.success({
            message: '心率测量成功！'
          })
        } else if (type === 'isGetAddressSending') {
          // console.log(value)
          // 转坐标
          pt = this.transPointToAddress(value)
          // console.log(pt)
          this.$notification.success({
            message: this.$t('home.locationSuccess')
          })
          if (this.isChangedPosition(pt)) {
            // 位置改变了
            this.info.lat = pt.lat
            this.info.lng = pt.lng
            this.info.coord_type = 'bd09'
            // bus.$emit('entityPositionChanged', this.info)
            this.$nextTick().then(() => {
              this.freshInfoBox(pt)
            })
            this.info.position_time = this.$moment().unix()
          } else {
            this.$nextTick().then(() => {
              this.freshInfoBox()
            })
          }
        } else if (type === 'isOpenLockSending') {
          // 根据值来判断
          if (value == 1 || value == 3) {
            this.info.wearcheck = value == 1 ? 0 : 1
            this.$notification.success({
              message: this.info.wearcheck === 1 ? this.$t('home.useWearCheck') : this.$t('home.nonuseWearCheck')
            })
          } else if (value == 2) {
            // 好像啥都不用做？
            // this.$message.success('命令执行成功！')
            this.$notification.success({
              message: this.$t('home.sendUnlockSuccess')
            })
          }
        }
        if (type !== 'isGetAddressSending') {
          // console.log(this.info)
          this.$nextTick().then(() => {
            this.freshInfoBox()
          })
        }
      },
      // 坐标转地址
      transPointToAddress (point) {
        let {coord, lat, lng} = point
        let lnglat = this.transToBd09(coord, lng, lat)
        let geoc = new window.BMap.Geocoder()
        let pt = new window.BMap.Point(lnglat[0], lnglat[1])
        let address = null
        // console.log(this.info)
        geoc.getLocation(pt, function (rs) {
          if (rs.address !== '') {
            address = rs.address;
          } else if ((rs.addressComponents.city !== '') && (rs.addressComponents
              .country !== '')) {
            address = rs.addressComponents.city + ', ' + rs.addressComponents
              .country;
          }
          let addressNodes = document.getElementsByName("address")
          // if(address != null && address.length > 10){
          //     address = address.substring(0,12) + '...'
          // }
          if (addressNodes) {
            for (var i = 0; i < addressNodes.length; i++) {
              addressNodes[i].innerHTML = address
              // console.log(address)
            }
          }
        })
        return pt
      },
      // 判断位置是否改变
      isChangedPosition (newPt) {
        // console.log(newPt)
        if (newPt.lng !== this.recordedPoint.lng || newPt.lat !== this.recordedPoint.lat) {
          return true
        } else {
          return false
        }
      }
    },
    sockets: {
      connect (data) {
        // console.log(data)
        // console.log('已成功连接到socket服务器')
        // console.log(this.token)
        // this.$socket.emit('init', this.token)
      },
      reconnect () {
        console.log('socket 重连')
      },
      disconnect () {
        console.log('socket 断开连接')
      },
      pushEvent (res) {
        console.log('已接收到socket推送的结果')
        // console.log(res)
        // console.log(this.info)
        let {entityId, event, data, timestamp} = res
        // 判断是否是当前有下发命令操作的实体
        if (this.isSendedCommandEntity(entityId)) {
          let resCommandType = this.checkSocketEventType(event)
          // 更新命令状态
          this.setSendStatus(entityId, resCommandType, false)
          // 如果是当前infoBox就更新视图
          if (entityId == this.info.id) {
            // console.log(this.info.id, entityId)
            // 是成功的返回
            if (res.status == 0) {
              // console.log('update')
              // 更新视图
              this.info.timestamp = timestamp
              this.updateInfo(resCommandType, data)
            } else {
              this.info.timestamp = timestamp
              // this.$message.error('命令执行失败！')
              if (event === 'heartRate' && data == '-1') {
                this.$notification.error({
                  message: this.$t('home.heartRateFailed')
                })
              } else {
                this.$notification.error({
                  message: this.$t('home.commandFailed')
                })
              }
              this.$nextTick().then(() => {
                this.freshInfoBox()
              })
            }
          }
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../theme/color.less';
  .address {
    display: inline-block;
    width: 210px;
    word-wrap:break-word;
    white-space:normal;
    // height: 40px;
  }
  .span-gap {
    margin-left: 15px;
  }
  .span-noraml {
    color: @heading-color;
    cursor: default;
    text-decoration: none;
    margin-left: 8px;
  }

  .icon-online {
    color: @primary-color;
  }

  .icon-offline {
    color: @disabled-color;
  }

  .icon-lg {
    font-size: 1.3rem;
  }

  .icon-md {
    font-size: 1.1rem;
  }

  .icon-alarm {
    color: @error-color;
    cursor: pointer;
  }

  .inline-a {
    display: inline-block;
    width: 40px;
  }

  .item-health {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-area: 8px;
    height: 80px;
    margin-top: 20px;
    .item {
      height: 30px;
      width: 115px;
      display: flex;
      justify-content: stretch;
      align-items: center;

      .span {
        display: inline-block;
        height: 30px;
        line-height: 30px;
      }
    }
  }
  .point-content{
    width: 370px;
  }

  .temp-item { display: flex; align-items: center; }
  .temp-col { display: flex; flex-direction: column; line-height: 1.2; }
</style>